import React from 'react';
import { TldOfferCarousel } from '../carousel/TldOfferCarousel';
import { TldOfferWidgetModule } from '../tldOfferWidget.module';
import { bmLayout } from './bm.layout';
export const BmCarousel = _ref => {
  let domain = _ref.domain;
  return /*#__PURE__*/React.createElement(TldOfferWidgetModule.Provider, {
    Layouts: {
      customConfiguration: bmLayout
    }
  }, /*#__PURE__*/React.createElement(TldOfferCarousel, {
    key: domain,
    domain: domain
  }));
};
//# sourceMappingURL=BmCarousel.js.map